window.languageIconFormatter = function(value) {
    if (value) {
        return '<span class="fi fi-'+value+'"></i>';
    }
    return '';
};
